module.exports = __webpack_public_path__ + "static/media/background.5b8e011a.png";